<template>
  <nav class="select-navigation fade-right" ref="periodNavigation">
    <div
      class="select-period"
      v-if="arrPeriod"
      @scroll="onScroll"
      ref="periodScroll"
      :style="{ background: backgorund }"
    >
      <ul class="period-list" :style="{width: arrPeriod.length * 50 +'px'}" ref="periodList">
        <li
          :class="defaultItem == item ? `period-active-${activePosition || 'bottom'}` : ''"
          :data-action="dataAction"
          :data-assetname="dataAssetname"
          :data-assettype="dataAssettype"
          :key="index"
          v-for="(item, index) in arrPeriod"
          @click="choosePeriod(item, index)"
        >{{ item }}</li>
      </ul>
    </div>
  </nav>
</template>
<script>
export default {
  props: {
    dataAction: {
      type: String,
      default: ""
    },
    dataAssetname: {
      type: String,
      default: ""
    },
    dataAssettype: {
      type: String,
      default: ""
    },
    arrPeriod: {
      type: Array,
      default: function() {
        return []
      }
    },
    alias: {
      type: String,
      default: ""
    },
    defaultItem: {
      type: String,
      default: "1Y"
    },
    activePosition: {
      type: String,
      default: "bottom"
    },
    backgorund: {
      type: String,
      default: "#f9f9f9"
    }
  },
  data() {
    return {}
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    }
  },
  watch: {
    $route() {
      let index = this.arrPeriod.indexOf(this.defaultItem)
      setTimeout(() => {
        this.choosePeriod(this.defaultItem, index)
      }, 100)
    }
  },
  mounted() {
    let index = this.arrPeriod.indexOf(this.defaultItem)
  },
  methods: {
    onScroll() {
      let periodScroll = this.$refs.periodScroll
      let periodList = this.$refs.periodList
      if (periodScroll && periodScroll.scrollLeft < 0) {
        this.$refs.periodNavigation.classList.remove("fade-left")
        this.$refs.periodNavigation.classList.add("fade-right")
      } else if (periodScroll && periodScroll.scrollLeft > 0) {
        this.$refs.periodNavigation.classList.add("fade-right")
        this.$refs.periodNavigation.classList.add("fade-left")
      } else {
        this.$refs.periodNavigation.classList.add("fade-right")
        this.$refs.periodNavigation.classList.remove("fade-left")
      }
      if (periodList.offsetWidth - periodScroll.offsetWidth == periodScroll.scrollLeft) {
        this.$refs.periodNavigation.classList.remove("fade-right")
      }
    },
    async choosePeriod(period, index) {
      this.$emit("update:defaultItem", period)
      this.$emit("select-data", period, this.alias) //( period, limitpage )
    }
  }
}
</script>
<style lang="scss" scoped>
.select-navigation {
  position: relative;
  user-select: none;
  .select-period {
    margin: 0;
    background: #f9f9f9;
    position: relative;
    overflow: auto;
    .period-list {
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        display: inline-block;
        max-width: 50px;
        cursor: pointer;
        width: 100%;
        @extend %font-size-ss;
        color: $color-normal-text;
        text-align: center;
        padding: 8px 0;
        z-index: 0;
      }
      .active {
        position: relative;
        font-weight: bold;
        &:after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          height: 3px;
          width: 100%;
          background-color: $color-normal-text;
          z-index: 1;
        }
      }
    }
  }
}
.fade-left {
  &:before {
    content: "";
    width: 50px;
    height: 100%;
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&1+0,0+100;White+to+Transparent */
    background: -moz-linear-gradient(left, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(
      left,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    ); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=1 ); /* IE6-9 */
  }
}
.fade-right {
  &:after {
    content: "";
    width: 50px;
    height: 100%;
    z-index: 1;
    position: absolute;
    right: 0;
    top: 0;
    pointer-events: none;
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+100 */
    background: -moz-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(
      left,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    ); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=1 ); /* IE6-9 */
  }
}
</style>